

export const FETCH_ALL = 'FETCH_ALL'; 
export const FETCH_ONE = 'FETCH_ONE';
export const SET_NULLS = 'SET_NULLS';
export const SET_SYMBOLS = 'SET_SYMBOLS';
export const AUTH = 'AUTH';
export const LOGOUT = 'LOGOUT';
export const ERROR = 'ERROR';
export const REMOVE = 'REMOVE';